<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="9.51343" cy="9.51343" r="9.5" fill="url(#paint0_radial_8468_6483)"/>
    <path d="M0.839493 9.43079C0.839493 4.68594 4.72293 0.839483 9.5134 0.839482C14.3039 0.839482 18.1873 4.68594 18.1873 9.43079" stroke-width="1.67893"/>
    <ellipse cx="9.4308" cy="9.59602" rx="5.01848" ry="5.01848" transform="rotate(180 9.4308 9.59602)" stroke-width="1.67893"/>
    <defs>
      <radialGradient id="paint0_radial_8468_6483" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.51343 9.51343) rotate(90) scale(9.5)">
        <stop offset="0.383919" stop-color="white" stop-opacity="0"/>
        <stop offset="1" stop-color="#E8E8E8"/>
      </radialGradient>
    </defs>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconAiAssistant'
}
</script>
